import React from 'react';
import ReactDOM from 'react-dom';
import Routing from 'config/routing';
import { Router, hashHistory } from 'react-router'

import Cliser from 'cliser';
import LoginModel from 'models/LoginModel';
import ConfigModel from 'models/ConfigModel';
import DeviceModel from 'models/DeviceModel';
import ImageModel from 'models/ImageModel';
import 'react-select/dist/react-select.css';

// Load window.fetch() polyfill
require('whatwg-fetch');

// Register common models
Cliser.use(LoginModel);
Cliser.use(ConfigModel);
Cliser.use(DeviceModel);
Cliser.use(ImageModel);

// Init React
ReactDOM.render(<Router history={hashHistory}>{Routing}</Router>, document.getElementById('application'));



// WEBPACK FOOTER //
// ./client/index.js